import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InvestmentInstruction } from '../../../../models/transactions/investment-instruction';
import { InvestmentInstructionSubmissionInstructionData } from '../../../../models/submissions/investment-instruction-submission-instruction-data';

@Component({
  selector: 'app-investment-instructions-card',
  templateUrl: './investment-instructions-card.component.html',
  styleUrls: ['./investment-instructions-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionsCardComponent {
  @Input() instruction!: InvestmentInstruction | InvestmentInstructionSubmissionInstructionData;
}
